import React, { useState } from 'react'
import { Text } from 'components/base'

import { Link } from 'react-router-dom'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import AnalyticsTable from '../components/AnalyticsTable'
import RoutesHelper from 'helpers/RoutesHelper'
import { SearchIcon, InfoIcon, NoteIcon } from 'components/Utils/Icons'
import SwitchableAnalyticsTable from '../components/SwitchableAnalyticsTable'
import providesOrganizationAnalytics from '../dataSync/providesOrganizationAnalytics'
import { getPopularSearchesQuery } from 'remote/analytics'

function SearchAnalytics({
  analytics: { popularSearches = [], popularSearchesWithoutResults = [] },
  analyticsFetchState: { loading },
}) {
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <React.Fragment>
      <section style={{ width: 300, height: 460 }}>
        <Text.Subtitle className="margin-bottom-large">Searches</Text.Subtitle>

        <SwitchableAnalyticsTable
          selectedTabIndex={selectedTab}
          onTabSwitched={setSelectedTab}
          tabs={[
            {
              name: 'Popular',
              renderTab: () => (
                <AnalyticsTable
                  loading={loading}
                  title="Term"
                  secondaryTitle="Searches"
                  entries={popularSearches}
                  renderPlaceholderIcon={() => (
                    <SearchIcon className="shade-30 margin-right-small" />
                  )}
                  renderRow={entry => {
                    return (
                      <TooltipOnHover
                        placement="top"
                        disabled={!entry.search}
                        tooltipContent={entry.search}
                      >
                        <section className="flexbox flexbox-align-center">
                          <SearchIcon
                            style={{ flexShrink: 0 }}
                            className="shade-30"
                            size={12}
                          />
                          <Text.Corpus className="margin-left-small ellipsis">
                            {entry.search}
                          </Text.Corpus>
                        </section>
                      </TooltipOnHover>
                    )
                  }}
                  renderValue={entry => {
                    return entry.count
                  }}
                />
              ),
            },
            {
              name: (
                <span className="position-relative">
                  Poor results
                  <TooltipOnHover
                    tooltipContent="Terms your team searched, for which they found no result."
                    placement="right"
                  >
                    <InfoIcon
                      size={16}
                      className="position-absolute margin-left-small shade-30"
                      style={{ top: -1 }}
                    />
                  </TooltipOnHover>
                </span>
              ),
              renderTab: () => (
                <AnalyticsTable
                  loading={loading}
                  title="Term"
                  secondaryTitle="Searches"
                  entries={popularSearchesWithoutResults}
                  renderPlaceholderIcon={() => (
                    <SearchIcon className="shade-30 margin-right-small" />
                  )}
                  renderRow={entry => {
                    return (
                      <TooltipOnHover
                        placement="top"
                        disabled={!entry.search}
                        tooltipContent={entry.search}
                      >
                        <section className="flexbox flexbox-align-center">
                          <SearchIcon
                            style={{ flexShrink: 0 }}
                            className="shade-30"
                            size={12}
                          />
                          <Text.Corpus className="margin-left-small ellipsis">
                            {entry.search}
                          </Text.Corpus>
                        </section>
                      </TooltipOnHover>
                    )
                  }}
                  renderValue={entry => {
                    return entry.count
                  }}
                />
              ),
            },
          ]}
        />
      </section>

      <section style={{ width: 345, height: 460 }}>
        <Text.Subtitle className="margin-bottom-large">&nbsp;</Text.Subtitle>

        <div style={{ height: 29 }} />

        <AnalyticsTable
          loading={loading}
          title="Popular match"
          secondaryTitle=""
          entries={
            selectedTab === 0 ? popularSearches : popularSearchesWithoutResults
          }
          renderRow={entry => {
            if (entry.popularMatchingNote) {
              return (
                <TooltipOnHover
                  placement="top"
                  disabled={!entry.popularMatchingNote.title}
                  tooltipContent={entry.popularMatchingNote.title}
                >
                  <Link
                    className="font-weight-medium pointer entity-highlight font-size-large flexbox flexbox-align-center padding-horizontal-smaller"
                    to={RoutesHelper.noteShow({
                      noteId: entry.popularMatchingNote.id,
                    })}
                  >
                    <NoteIcon size={12} style={{ flexShrink: 0 }} />
                    <span className="margin-left-smaller ellipsis">
                      {entry.popularMatchingNote.title || 'Untitled'}
                    </span>
                  </Link>
                </TooltipOnHover>
              )
            }

            return (
              <Text.Corpus className="ellipsis" style={{ lineHeight: '24px' }}>
                None
              </Text.Corpus>
            )
          }}
          renderValue={() => {}}
        />
      </section>
    </React.Fragment>
  )
}

export default providesOrganizationAnalytics(getPopularSearchesQuery)(
  SearchAnalytics
)
